import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { track } from '@/api/tracking'

const CALENDAR_URL = 'https://calendar.app.google/xhG3eKvC6bb1Mk6eA'

const trackScheduleRedirect = () =>
    new Promise<void>(resolve => {
        track(
            'schedule_redirect_started',
            {
                destination_url: CALENDAR_URL,
                source_path: window.location.pathname,
            },
            { transport: 'sendBeacon', send_immediately: true },
            () => resolve(),
        )
    })

export function SchedulePage() {
    const { t } = useTranslation()

    useEffect(() => {
        let isCancelled = false

        const sendEventAndRedirect = async () => {
            await trackScheduleRedirect()
            if (isCancelled) return
            window.location.replace(CALENDAR_URL)
        }

        sendEventAndRedirect().catch(() => {
            if (isCancelled) return
            window.location.replace(CALENDAR_URL)
        })

        return () => {
            isCancelled = true
        }
    }, [])

    return (
        <div className='mx-auto flex min-h-screen w-full max-w-md flex-col items-center justify-center gap-4 px-4 text-center'>
            <p className='text-foreground'>{t('schedule.redirecting', 'Te estamos llevando al calendario…')}</p>
            <p className='text-sm text-muted-foreground'>
                {t(
                    'schedule.manualFallback',
                    'Si sigues en esta página en unos segundos, abre el calendario con el enlace de abajo.',
                )}
            </p>
            <a
                href={CALENDAR_URL}
                className='font-medium text-primary underline underline-offset-4 focus-visible:rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring'
            >
                {t('schedule.openCalendar', 'Abrir calendario')}
            </a>
        </div>
    )
}
